import { contents } from '@/utils/core/constants';

import type { DropdownOption } from '../types';
import type { CacheItem } from '@/app/store/slices/cacheSlice';

type ValueProtectionProfile = {
    srvPrflSrv?: Array<{ cd?: string }>;
    srvPrflCfgKey?: Array<{ cd: string; $: string }>;
};

/**
 * Transforms currency items into dropdown options
 */
export const transformCurrenciesToOptions = (currencies?: CacheItem[]): DropdownOption[] => {
    if (!Array.isArray(currencies)) return [];

    return currencies.map((currency) => ({
        label: currency?.cd,
        value: currency?.cd,
    }));
};

const shouldShowProtectionValue = (servicePointServices: string[]): boolean => {
    // REQUIREMENT SAID ONLY THESE CODES ARE ALLOWED: II, IE, IB, IG
    const allowedCodes = new Set(['II', 'IE', 'IB', 'IG']);
    return (servicePointServices ?? []).some((code) =>
        allowedCodes.has(String(code).trim().toUpperCase()),
    );
};

export const isValueProtectionAllowedForProfile = (
    profile?: ValueProtectionProfile | null,
): boolean => {
    const servicePointServices = (profile?.srvPrflSrv ?? [])
        .map((item) => item?.cd)
        .filter((cd): cd is string => Boolean(cd));
    const isFeatureFlagEnabled =
        profile?.srvPrflCfgKey?.find(
            (item) => item.cd === contents.SHIPMENT_VALUE_PROTECTION_ENABLED,
        )?.$ === 'Y';
    return shouldShowProtectionValue(servicePointServices) && Boolean(isFeatureFlagEnabled);
};
